module.exports = __webpack_public_path__ + "img/logoTextWhite.c8af7f9f.svg";